// Gyorstájékoztatóhoz kapcsolódó szimbólumok.
export default [
  '&#9679;', // kör
  '&#9632;', // négyzet
  '&#9830;', // rombusz
  '&#9650;', // háromszög
  '&#9660;', // fordított háromszög
  '&#9733;', // csillag
  '&#9827;', // treff
];
